import House from './House'
import Island from './Island'
import Text from './Text'

export default function Scene(props) {
    
    // Debug: vediamo tutti i nodi disponibili
    console.log("Nodi disponibili:", Object.keys(props.nodes))
    
    return <>
        <House nodes={ props.nodes }/>
        <Island nodes={ props.nodes } />
        <Text nodes={ props.nodes } />
    </>
}